import { mustStartEndLetter } from './helper/ValidatorRules'

const mustStartEndLetterValidator = {
  getMessage: () => 'Sorry, the value you have entered is invalid. Please enter a valid value that starts and ends with a letter.',
  validate: value => {
    return {
      valid: mustStartEndLetter(value),
      data: {
        required: true
      }
    }
  }
}

export default mustStartEndLetterValidator
